import getDataAttribute from "./getDataAttribute";

// Merged default config with js config with data attribute config
const mergeConfig = (
  DOMElement,
  userJSConfig,
  attributeName,
  defaultValue,
  parseData
) => {
  // If JS Config exists, overwrite default value to be used if data attribute is not provided
  if (userJSConfig && userJSConfig[attributeName] !== undefined) {
    defaultValue = userJSConfig[attributeName];
  }

  return getDataAttribute(
    DOMElement,
    attributeName.toLowerCase(),
    defaultValue,
    parseData
  );
};

export default mergeConfig;
